import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import AccessStepper from './components/AccessStepper';
import AccessSuccessDialog, { AccessSuccessKindEnum } from './components/AccessSuccessDialog';
import EntitySearchPanel from './components/EntitySearchPanel';
import MemberDetailsPanel from './components/MemberDetailsPanel';
import SubBrokerRegisterPanel from './components/SubBrokerRegisterPanel';
import { resolvePortalAccessFlowConfig } from './config';
import { PortalAccessStepEnum } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './types';
export { AccessSuccessKindEnum } from './components/AccessSuccessDialog';
export { DEFAULT_ACCESS_COUNTRIES, DEFAULT_ACCESS_ENTITIES, DEFAULT_ACCESS_PRODUCTS, resolvePortalAccessFlowConfig } from './config';
/**
 * Portal access-request flow view (one component with three scenarios, visibility controlled by the step value):
 * 1. entitySearch       — search and select an existing sub-broker entity (design search_1)
 * 2. memberDetails      — fill in member basics and submit the request (request_1, success dialog success_1)
 * 3. subBrokerRegister  — register a new agency as a sub-broker (subbroker_1, success dialog success_2)
 */

export var PortalAccessFlowView = function PortalAccessFlowView(props) {
  var _config$copy$stepper;

  var email = props.email,
      initialStep = props.initialStep,
      onExit = props.onExit,
      onContactBroker = props.onContactBroker,
      onStepChange = props.onStepChange;
  var config = resolvePortalAccessFlowConfig(props);

  var _useState = useState(initialStep || PortalAccessStepEnum.EntitySearch),
      step = _useState[0],
      setStep = _useState[1];

  var _useState2 = useState(),
      selectedEntity = _useState2[0],
      setSelectedEntity = _useState2[1];

  var _useState3 = useState(false),
      submitting = _useState3[0],
      setSubmitting = _useState3[1];

  var _useState4 = useState(false),
      successOpen = _useState4[0],
      setSuccessOpen = _useState4[1];

  var _useState5 = useState(AccessSuccessKindEnum.Member),
      successKind = _useState5[0],
      setSuccessKind = _useState5[1];

  var isSubBrokerStep = step === PortalAccessStepEnum.SubBrokerRegister;
  var stepperIndex = successOpen && successKind === AccessSuccessKindEnum.Member ? 2 : step === PortalAccessStepEnum.MemberDetails ? 1 : 0;
  /**
   * request
   */

  var requestAccessSubmit = function requestAccessSubmit() {
    // demo: no request API yet — treat the submit as successful after a fixed 900ms
    return new Promise(function (resolve) {
      return setTimeout(resolve, 900);
    });
  };
  /**
   * effects
   */


  useEffect(function () {
    onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(step);
  }, [step]);
  /**
   * methods
   */

  var continueWithEntityAction = function continueWithEntityAction(entity) {
    setSelectedEntity(entity);
    setStep(PortalAccessStepEnum.MemberDetails);
  };

  var registerInsteadAction = function registerInsteadAction() {
    setStep(PortalAccessStepEnum.SubBrokerRegister);
  };

  var backToSearchAction = function backToSearchAction() {
    setStep(PortalAccessStepEnum.EntitySearch);
  };

  var submitMemberAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting(true);
              _context.next = 3;
              return requestAccessSubmit();

            case 3:
              setSubmitting(false);
              setSuccessKind(AccessSuccessKindEnum.Member);
              setSuccessOpen(true);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submitMemberAction() {
      return _ref.apply(this, arguments);
    };
  }();

  var submitSubBrokerAction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmitting(true);
              _context2.next = 3;
              return requestAccessSubmit();

            case 3:
              setSubmitting(false);
              setSuccessKind(AccessSuccessKindEnum.SubBroker);
              setSuccessOpen(true);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function submitSubBrokerAction() {
      return _ref2.apply(this, arguments);
    };
  }();

  var closeSuccessAction = function closeSuccessAction() {
    setSuccessOpen(false);
    onExit === null || onExit === void 0 ? void 0 : onExit();
  };

  var contactBrokerAction = function contactBrokerAction() {
    onContactBroker === null || onContactBroker === void 0 ? void 0 : onContactBroker();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "relative flex w-full flex-1 flex-col bg-[var(--brand-surface)]",
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "mx-auto flex w-full max-w-[640px] flex-1 flex-col space-y-8 px-4 py-10 md:px-6 md:py-14",
      children: [!isSubBrokerStep && /*#__PURE__*/_jsx(AccessStepper, {
        steps: ((_config$copy$stepper = config.copy.stepper) === null || _config$copy$stepper === void 0 ? void 0 : _config$copy$stepper.steps) || [],
        activeIndex: stepperIndex
      }), step === PortalAccessStepEnum.EntitySearch && /*#__PURE__*/_jsx(EntitySearchPanel, {
        email: email,
        entities: config.entities,
        copy: config.copy.search,
        onContinue: continueWithEntityAction,
        onRegisterInstead: registerInsteadAction,
        onContactBroker: contactBrokerAction
      }), step === PortalAccessStepEnum.MemberDetails && selectedEntity && /*#__PURE__*/_jsx(MemberDetailsPanel, {
        entity: selectedEntity,
        email: email,
        copy: config.copy.member,
        submitting: submitting,
        onSubmit: submitMemberAction,
        onChangeEntity: backToSearchAction,
        onContactBroker: contactBrokerAction
      }), isSubBrokerStep && /*#__PURE__*/_jsx(SubBrokerRegisterPanel, {
        email: email,
        copy: config.copy.subBroker,
        submitting: submitting,
        onSubmit: submitSubBrokerAction,
        onBack: backToSearchAction
      })]
    }), /*#__PURE__*/_jsx(AccessSuccessDialog, {
      open: successOpen,
      kind: successKind,
      copy: config.copy.success,
      entity: selectedEntity,
      onClose: closeSuccessAction
    })]
  });
};
export default PortalAccessFlowView;